import papa from 'papaparse'

const BLOG_CROP_MASTER_CSV_CONTENT_URL = '/blog/wp-content/uploads/crop-master-onboarding-links.csv'

export const DEFAULT_LINKS = {
  video: {
    en: 'https://www.youtube.com/embed/kIrywyFE-R8',
    es: 'https://www.youtube.com/embed/KTbl6YuP65U',
    pt: 'https://www.youtube.com/embed/0UX7PZYYibo'
  },
  academy: 'https://campus.cropmaster.academy',
  about: 'https://docs.layers.hemav.com/es/getting-started/cropmaster.html'
}

export const getCropMasterLinks = async () => {
  try {
    const response = await fetch(`${BLOG_CROP_MASTER_CSV_CONTENT_URL}?nocache=${Date.now()}`)
    const csv = await response.text()
    const { data } = papa.parse(csv, { header: true })
    if (data.length > 1) throw new Error('invalid-crop-master-links-csv')
    return {
      video: {
        en: data?.[0]?.en,
        es: data?.[0]?.es,
        pt: data?.[0]?.pt
      },
      academy: data?.[0]?.academy,
      about: data?.[0]?.about
    }
  } catch (error) {
    console.error(error)
    return DEFAULT_LINKS
  }
}

export const getYoutubeThumbnail = videoUrl => {
  if (!videoUrl) return ''
  const match = videoUrl.match(/embed\/([a-zA-Z0-9_-]+)/)
  return match && match[1] ? `https://img.youtube.com/vi/${match[1]}/hqdefault.jpg` : ''
}

export const getBackgroundStyles = (CmPageBg, themeColors) => ({
  bgStyle: {
    position: 'fixed',
    inset: 0,
    zIndex: 0,
    backgroundImage: `url(${CmPageBg})`,
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center center',
    pointerEvents: 'none'
  },
  overlayStyle: {
    position: 'fixed',
    inset: 0,
    zIndex: 1,
    background: themeColors.blueColorOpacity,
    pointerEvents: 'none'
  }
})
